import { useSelector } from "react-redux";

import { RootState } from "../store/store";

/** Tenant flag: Figma auth/home UI + AI intake matching (Command Center). */
export function useAiMatchingPreview(): boolean {
  const configLoaded = useSelector((state: RootState) => state.config.configLoaded);
  const aiMatchingPreview = useSelector((state: RootState) => state.config.aiMatchingPreview);
  return configLoaded && aiMatchingPreview;
}
